import React, { useState } from "react";
import "./pdView.scss";
import FormInputWithHeader from "../../../common/FormInputWithHeader";
import { UPDATE_PATIENT_DETAILS } from "../../ERXViewApiHandler/apiConstants";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import swal from "sweetalert";
import AgePickerComponent from "../../common/AgePickerComponent";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const PDView = (props) => {
  const {
    patientDetails,
    genderOptions,
    patientAge: patientDetailsAge,
    appointmentData,
    handlePatientName,
    handlePatientAge,
    handleGender,
    getPatientDetailsApi,
  } = props;

  const user_type = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const [loader, setLoader] = useState(false);
  const [ageEdited, setAgeEdited] = useState(false);
  const [updateOnGet, setUpdateonGet] = useState(true);
  const [patientName, setPatientName] = useState(patientDetails?.patient_name);
  const [patientAge, setPatientAge] = useState(patientDetailsAge);
  const [patientGender, setPatientGender] = useState({
    label: patientDetails?.patient_gender,
  });

  // Actions ===>

  const handleSavePatientDetails = () => {
    setLoader(true);
    // below functions are setting values to parent patient details object
    patientGender?.id > 0 && handleGender(patientGender);
    patientName?.length > 0 &&
      handlePatientName({ target: { value: patientName } });
    patientAge?.length > 0 && handlePatientAge(patientAge);

    let reqPayload = {
      "authorizer-principal-id": {
        user_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
      },
      appointment_id: appointmentData?.appointment_id,
      data: {
        ...patientDetails,
        patient_name: patientName,
        patient_gender: patientGender.label,
        patient_age:
          patientDetails?.patient_dob || !ageEdited
            ? patientDetails?.patient_age
            : patientAge, //  + " years 00 months 00 days",
      },
    };
    if (ageEdited) {
      const parts = patientAge.split(" ");
      let valid = false;
      parts.forEach((part) => {
        const num = parseInt(part, 10);
        if (!isNaN(num) && num >= 1) {
          valid = true;
        }
      });
      if (!valid) {
        setLoader(false);
        swal({
          title: "Please enter valid age",
          icon: "warning",
          timer: 2000,
        });
        setPatientAge(patientDetailsAge);
        getPatientDetailsApi();
        setUpdateonGet(true);
        return;
      }
    }
    const resData = c2cPostApiHandler(UPDATE_PATIENT_DETAILS, reqPayload);
    resData.then(([res, error]) => {
      setLoader(false);
      if (!error) {
        if (res?.data?.statusCode === 200) {
          swal({
            title: "Patient Details Updated Successfully",
            icon: "success",
            timer: 2000,
          });
          getPatientDetailsApi();
          setUpdateonGet(true);
        }
      }
    });
  };

  // <===

  return (
    <div className="patient-details-view-wrapper">
      {loader && (
        <div className="loader-container">
          <div className="load-loader">
            <div className="spinner-border text-dark" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      <div
        className="patient-details-view"
        style={{ display: window.innerWidth > 767 ? "" : "block" }}
      >
        <div
          style={{
            width: window.innerWidth > 767 ? "250px" : "100%",
            marginRight: "15px",
            marginBottom: window.innerWidth > 767 ? "" : "15px",
          }}
        >
          <FormInputWithHeader
            title="Patient Name"
            type="text"
            value={patientName}
            handleOnChangeInput={(e) => {
              setPatientName(e.target.value);
            }}
          />
        </div>
        <div
          className="d-flex ai-center"
          style={{ marginBottom: window.innerWidth > 767 ? "" : "10px" }}
        >
          <div
            style={{
              marginBottom: "15px",
            }}
          >
            <AgePickerComponent
              value={patientAge}
              disabled={patientDetails?.patient_dob}
              updateOnGet={updateOnGet}
              handleOnChangeInput={(data) => {
                setPatientAge(data);
                setAgeEdited(true);
                setUpdateonGet(false);
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: window.innerWidth > 767 ? "flex" : "",
          justifyContent: window.innerWidth > 767 ? "space-between" : "",
        }}
      >
        <div
          style={{
            width: window.innerWidth > 767 ? "140px" : "100%",
            marginRight: window.innerWidth > 767 ? "15px" : "",
          }}
        >
          <FormInputWithHeader
            title="Gender"
            inputType="dropdown"
            value={patientGender.label}
            options={genderOptions}
            handleOnChangeInput={(e) => {
              setPatientGender(e);
            }}
          />
        </div>
        <div
          className={`patient-details-save-btn ${
            patientDetails?.patient_name ? "" : "pd-disabled-btnclr"
          }`}
          onClick={
            patientDetails?.patient_name ? handleSavePatientDetails : null
          }
        >
          Save
        </div>
      </div>
    </div>
  );
};

export default PDView;
